import React,{useState,forwardRef} from 'react'
import SoiltestContent from './SoiltestContent'

const SoiltestPage = forwardRef((props, ref) => {
  const [isSticky, setSticky] = useState(true);
  const displline=true;
  return (
    <>
   
    <div>
     
    <SoiltestContent/>
   
    </div>
    </>
  )
});
SoiltestPage.displayName="SoiltestPage";
export default SoiltestPage
